import instance from '../utils/axios';

class QrCodeProjectDetailsService {

    async getProjectInfo(corpId, projectId) {
        return await instance.post('/crm/crm/project/getProjectInfo', {
            corpId: corpId,
            projectId: projectId
        });
    }

}

export default new QrCodeProjectDetailsService();